<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal" v-if="!web_403"></div>
                <div class="dialog-wrapper">
                    <div class="title"></div>
                    <div class="msg-view">
                        <vuescroll>
                            <div class="story">
                                一盏魂灯，生了灵识，初到人间。辗转人间数载，止步于河内，同心向江湖与自由的少女张春华相遇，感其志，遂应其愿，入主其躯，代她成为新的“张春华”。<br>
                                <br>
                                魂灯生出灵识不久，人间沉浮，懵懂不知，全凭一颗好奇之心驱策，但观人间百态鲜活有趣，乐此不疲。嫁入司马家后，为那名唤司马懿的青衫书生吸引，日子是柴米油盐，晨昏定省，是学习如何将“张春华”的角色扮演到滴水不漏。但这“张春华”皮相里存的，终究只有一盏赤条条来去、无牵无挂的灯。岁月流转。她渐渐习得人情，也在不知不觉间觉醒感应人心的能力。这样一盏灯，就如此般悄无声息地，将光芒照进了司马懿宛如古井的命途中。<br>
                                <br>
                                后来雨夜惊雷，司马懿为谢绝黑暗霸主曹操的征召，推说染病，不想曹操留有后手，派遣暗夜组织杀手秘密监视，撞破此装病之秘。杀机骤起。那是她第一次直视司马懿的野心，得以见到缕萦绕不去的与世纷争且向上攀登的死气。<br>
                                <br>
                                可她也听见卑微生命的颤抖与呐喊。<br>
                                <br>
                                听见那些因他野心而步入歧途的魂灵的声音，听见无数绝望与悔恨的嘶鸣。司马懿不再只是她眼中那口深邃神秘的古井，更成了吸附死气、催生权欲的深渊。他的路愈走愈暗，而她心中那点莹蓝的灯焰，则照见了与之截然相反的方向。<br>
                                <br>
                                长夜漫漫，井深如狱。<br>
                                <br>
                                她曾无情无欲，率性而行，学习为人，感知人心，历经悲喜，直到此刻，在司马懿赤裸的野心与自身无法漠然的悲悯拉扯中，她记起来自己的根本。一盏游离人间的魂灯，也是河内司马家的主母张春华。如非死物，当溯光而行，哪怕那光微弱，哪怕前路混沌。这人间，她来过了，看过了，爱过了，终也找到了自己那点光，该去的方向。
                            </div>
                        </vuescroll>
                    </div>                   
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.msg-modal{
    // position: relative;
    width: 650px;
    height: 684px;
    background-image: url(~@/assets/images/modal/bg-modal_lg.png);  
}

.title{
    width: 100%;
    height: 41px;
    margin: 0 auto 10px;
    background-repeat : no-repeat;
    background-position : center;
    background-image: url(~@/assets/images/modal/title-story.png);  
}

.msg-view{
    width: 600px;
    height: 560px;
    margin: 0 auto;
    font-size: 22px;
    color: #daefff;
    line-height: 1.4;
    text-align: left;
}

.story{
    padding-right: 20px;
}

.u-ctrl .u-btn.ok{
    width: 279px;
    height: 87px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/modal/btn-ok.png);     
}


</style>

<style lang="scss">
.msg-view{
    b{
        color: #f95148;
    }    
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 'notice',
            web_403 : false,
            config : {
                'notice' : {
                    title : 'notice',
                },
                'cash' : {
                    title : 'cash',
                    text : '兑换的现金红包将在活动结束后的30个工作日内，发放至您填写的对应支付宝账号，请注意查收~',
                },
                'bind-error' : {
                    title : '助力失败',
                    text : '请稍后再试~',
                },
                'share-error' : {
                    title : '助力失败',
                    text : '请稍后再试~',
                },                
                'apply-success' : {
                    title : '助力成功',
                    text : '奖励已发放至军师邮箱或网页活动，请及时领取',
                },
                'apply-error' : {
                    title : '助力失败',
                    text : '请稍后再试~',
                },
                'error' : {
                    title : '助力失败',
                    text : '请稍后再试~',
                }
            },
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },            
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>